import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles(() => ({

    menuSliderContainer: {
        width: 250,
        background: "black",
        height: "100%",
        padding: '2rem',
    },
    active: {
        color: 'orange',
        "& .MuiTypography-body1": {
            '@media (max-width:1200px)': {
                fontSize: '0.9rem',
            },
            '@media (min-width:1200px)': {
                fontSize: '1.1rem',
            },
        },
    },
    listItem: {
        color: "whitesmoke",
        "&:hover": {
            color: "orange",
        },
        "& .MuiTypography-body1": {
            '@media (max-width:1200px)': {
                fontSize: '0.9rem',
            },
            '@media (min-width:1200px)': {
                fontSize: '1.1rem',
            },
        },
    },
}));

const Sidebar = ({ navItems }) => {

    const classes = useStyles();

    return (
        <Box className={classes.menuSliderContainer} component="div">
            <Divider />
            <List>
                {navItems.map((item) => (
                    <ListItem
                        key={item.listText}
                        className={document.location.pathname === item.listPath ? classes.active : classes.listItem}
                        component={Button}
                        href={item.listPath}>
                        <ListItemIcon className={classes.listItem}>
                            {item.listIcon}
                        </ListItemIcon>
                        <ListItemText primary={item.listText} />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
}

export default Sidebar
